import axios from 'axios'

export const API_ENDPOINT = process.env.REACT_APP_API_BASE_URL

const getConfig = () => {
  const jwtToken = localStorage.getItem('jwtToken')

  return {
    headers: {
      Authorization: jwtToken ? `Bearer ${jwtToken}` : null,
    },
  }
}

export const registerDevice = pushToken => {
  return axios.post(API_ENDPOINT + '/api/register-device', { pushToken }, getConfig())
}

export const login = (email, password) => {
  return axios.post(API_ENDPOINT + '/oauth/token', {
    client_id: process.env.REACT_APP_AUTH_CLIENT,
    client_secret: process.env.REACT_APP_AUTH_CODE,
    grant_type: 'password',
    scope: '*',
    username: email,
    password: password,
  })
}

export const fetchProfile = () => {
  return axios.get(API_ENDPOINT + '/api/users/me', getConfig())
}

export const fetchEntries = (fromDate, toDate, greenhouses, farmers) => {
  return axios.post(API_ENDPOINT + '/api/entries/search', { fromDate, toDate, greenhouses, farmers }, getConfig())
}

export const fetchEntriesExcel = (fromDate, toDate, greenhouses) => {
  return axios.post(
    API_ENDPOINT + '/api/entries/csv',
    { fromDate, toDate, greenhouses },
    {
      ...getConfig(),
      responseType: 'arraybuffer',
    },
  )
}

export const fetchEntry = entryId => {
  return axios.post(API_ENDPOINT + '/api/entries/search', { entryId }, getConfig())
}

export const fetchSamplings = (fromDate, toDate, greenhouses, farmers) => {
  return axios.post(API_ENDPOINT + '/api/samplings/search', { fromDate, toDate, greenhouses, farmers }, getConfig())
}

export const fetchSamplingsExcel = (fromDate, toDate, greenhouses) => {
  return axios.post(
    API_ENDPOINT + '/api/samplings/csv',
    { fromDate, toDate, greenhouses },
    {
      ...getConfig(),
      responseType: 'arraybuffer',
    },
  )
}

export const fetchSampledEntry = entryId => {
  return axios.post(API_ENDPOINT + '/api/samplings/search', { entryId }, getConfig())
}

export const fetchEntriesFilters = (fromDate, toDate) => {
  return axios.post(API_ENDPOINT + '/api/entries/search/filter-values', { fromDate, toDate }, getConfig())
}

export const fetchPaginatedFarmers = (page, id) => {
  return axios.get(API_ENDPOINT + '/api/paginatedFarmers?page=' + page, {
    ...getConfig(),
    params: {
      id: id
    }
  })
}

export const findFarmerByName = (name,id) => {
  return axios.post(API_ENDPOINT + '/api/farmerByName', {name,id}, getConfig())
}

export const fetchSelectedEntriesFiltersValues = () => {
  return axios.get(API_ENDPOINT + '/api/entries/search/filter-values', getConfig())
}

export const fetchPreferences = () => {
  return axios.get(API_ENDPOINT + '/api/preferences', getConfig())
}

export const updatePreferences = preferences => {
  return axios.put(API_ENDPOINT + '/api/preferences', preferences, getConfig())
}

export const changePassword = (oldPassword, newPassword) => {
  return axios.post(API_ENDPOINT + '/api/preferences/change-password', { oldPassword, newPassword }, getConfig())
}

export const fetchNotifications = () => {
  return axios.get(API_ENDPOINT + '/api/notifications', getConfig())
}

export const markNotificationAsRead = id => {
  return axios.patch(API_ENDPOINT + '/api/notifications/' + id + '/mark-as-read', {}, getConfig())
}

export const markAllNotificationsAsRead = () => {
  return axios.get(API_ENDPOINT + '/api/notifications/mark-all-as-read', getConfig())
}

export const fetchInvoices = (fromDate, toDate) => {
  return axios.post(API_ENDPOINT + '/api/invoices', { fromDate, toDate }, getConfig())
}

export const fetchStatsByFarm = (period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-farm',
    { period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByGreenhouse = (farmId, period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-greenhouse',
    { farmId, period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByProduct = (period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-product',
    { period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByProductByFarm = (productTypeId, period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-farm',
    { productTypeId, period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByProductByGreenhouse = (productTypeId, farmId, period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-greenhouse',
    { productTypeId, farmId, period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByProductPrice = (period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-product-price',
    { period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchStatsByProductAveragePrice = (period1FromDate, period1ToDate, period2FromDate, period2ToDate) => {
  return axios.post(
    API_ENDPOINT + '/api/stats/by-product-average-price',
    { period1FromDate, period1ToDate, period2FromDate, period2ToDate },
    getConfig(),
  )
}

export const fetchForecasts = (fromDate, toDate, greenhouses) => {
  return axios.post(API_ENDPOINT + '/api/forecasts/search', { fromDate, toDate, greenhouses }, getConfig())
}

export const fetchSingleForecast = entryId => {
  return axios.post(API_ENDPOINT + '/api/forecasts/search', { entryId }, getConfig())
}

export const createForecast = forecast => {
  return axios.post(API_ENDPOINT + '/api/forecasts/create', forecast, getConfig())
}
export const updateForecast = forecast => {
  return axios.post(API_ENDPOINT + '/api/forecasts/update', forecast, getConfig())
}

export const fetchForecastOptions = (day = new Date()) => {
  return axios.get(API_ENDPOINT + '/api/forecasts/product-options', { ...getConfig(), params: day })
}

export const sendForecast = forecast => {
  return axios.post(API_ENDPOINT + '/api/forecast', forecast, getConfig())
}

export const fetchContainerBalances = () => {
  return axios.get(API_ENDPOINT + '/api/containers/balances', getConfig())
}



// WEBPACK FOOTER //
// ./src/api.js